import { styled } from '@goodfynd/theme';

export const StyledContainer = styled('section', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 32,
  '@smMax': {
    gap: 16,
  },
});
